// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";
import router from "./router/index.js";
import Vuex from "vuex";
import store from "./vuex/store";
import axios from "axios";
// import md5 from 'js-md5';
import { baseUrl, basePlatform, appVersion } from "./config/env.js";
import md5 from "../static/lib/md5.min.js";
import {
  freeCheck,
  freeDeliver,
  insUserInfo,
  insMedia
} from "@/service/service.js";

Vue.use(Vuex);
Vue.use(VueRouter);
/* eslint-disable no-new */
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  },
  created() {
    store.dispatch("initApp");
  }
});

window.confirm = function(message) {
  //改写系统的confirm
  var iframe = document.createElement("IFRAME");
  iframe.style.display = "none";
  iframe.setAttribute("src", "data:text/plain,");
  document.documentElement.appendChild(iframe);
  var alertFrame = window.frames[0];
  var result = alertFrame.window.confirm(message);
  iframe.parentNode.removeChild(iframe);
  return result;
};

router.beforeEach(function(to, from, next) {
  console.info("beforeEach:", {
    to,
    from,
    next
  });

  store.dispatch("updateMidLoadingShow", {
    midLoadingShow: true,
    midLoadingText: ""
  });
  store.dispatch("updateCoinShow", {
    coinShow: false
  });
  store.dispatch("updateCollectShow", {
    //显示收藏
    collectShow: true
  });

  let TO_PATH_ARR = to.path.split("/");
  let TO_PATH = TO_PATH_ARR[TO_PATH_ARR.length - 1];

  switch (TO_PATH) {
    case "follow":
      store.dispatch("updateTabSeleced", {
        tabSeleced: "follow"
      });
      break;
    case "like":
      store.dispatch("updateTabSeleced", {
        tabSeleced: "like"
      });
      break;
    case "coin":
      store.dispatch("updateTabSeleced", {
        tabSeleced: "coin"
      });
      break;
    case "view":
      store.dispatch("updateTabSeleced", {
        tabSeleced: "view"
      });
      break;
    default:
  }

  next();
});

router.afterEach(route => {
  window.scrollTo(0, 0);
});
//---------------------commonJS------------------------------------------------

function isLocalStorageMain() {
  var Key = "test",
    storage_main = window.localStorage;
  try {
    storage_main.setItem(Key, "testValue");
    storage_main.removeItem(Key);
    console.log("can localStorage");
    return true;
  } catch (error) {
    console.log("no localStorage");
    return false;
  }
}

Vue.prototype.$http = axios;

Vue.prototype.isLocalStorage = () => {
  //判断浏览器是否支持localStorage
  var testKey = "test",
    storage = window.localStorage;
  try {
    storage.setItem(testKey, "testValue");
    storage.removeItem(testKey);
    console.log("can localStorage");
    return true;
  } catch (error) {
    console.log("no localStorage");
    return false;
  }
};

Vue.prototype.encryption = function(str) {
  var result = md5(str);
  return result;
};

const resolveUserInfo = stringData =>
  new Promise((resolve, reject) => {
    // console.log("stringData:",stringData)
    try {
      if (stringData == "") {
        reject("empty string");
      } else {
        resolve(stringData.graphql);
      }
    } catch (error) {
      reject(error);
    }
  });

Vue.prototype.updateUsersInfoByUserName = function(
  userName,
  successCallBack,
  falseCallBack,
  loadingOnOff
) {
  //根据userName获取info
  // https://https://https://https://test.wefollow.co/inswww/[user_name]/?__a=1
  //https://https://https://https://test.wefollow.co/inswww/[user_name]/?__a=1
  if (userName === "&" || !userName) {
    falseCallBack();
  } else {
    var that = this;

    insUserInfo(userName).then(
      response => {
        // success callback
        //  return response.body
        console.log("解析到的字符串:", response);
        resolveUserInfo(response.data)
          .then(data => {
            console.log("resolveUserInfo", data);
            that.$store.commit("updateUserInfo", {
              userInfo: data
            });
            if (successCallBack) {
              successCallBack();
            }
            store.dispatch("updateMidLoadingShow", {
              midLoadingShow: false,
              midLoadingText: ""
            });
          })
          .catch(error => {
            store.dispatch("updateMidLoadingShow", {
              midLoadingShow: false,
              midLoadingText: ""
            });
          });
      },
      response => {
        // error callback
        ga("send", {
          hitType: "event",
          eventCategory: "Get_user_info failed",
          eventAction: "net_err"
        });

        console.log("失败:" + response);
        if (falseCallBack) {
          falseCallBack();
        }
        store.dispatch("updateMidLoadingShow", {
          midLoadingShow: false,
          midLoadingText: ""
        });
        console.info(arguments);
        if (loadingOnOff) {
          //为键盘确定的时候
          console.log("keyenter");
          store.dispatch("updateToastShow", {
            //失败Toast
            toastShow: true,
            toastText: "No people found, please check your username.",
            position: "top"
          });
        } else {
          console.log("clickenter");
          store.dispatch("updateToastShow", {
            //失败Toast
            toastShow: true,
            toastText: "No people found, please check your username."
          });
        }
      }
    );
  }
};

Vue.prototype.updateUsersMediaListById = function(
  morePage,
  successCallBack,
  falseCallBack
) {
  //根据userName获取info
  //https://test.elsonwx.com/ins/api/google/media/?uuid_token=12312312&max_id=1471960586739830968_1067259270&user_id=1067259270
  if (this.$route.params.userName == "&") {
    //没有用户名id
  } else {
    var MaxId = "";
    if (morePage) {
      //需要加载更多
      if (!this.$store.state.mediaListTag.more_available) {
        //如果不存在 more_available=ture 加載更多一页

        if (successCallBack) {
          successCallBack();
        }
        return false;
      } else {
        MaxId = this.$store.state.mediaListTag.max_id;
      }
    } else {
    }

    var that = this;
    function getData(data) {
      let userId = "";
      let userName = "";
      if (that.$store.state.urlData.username == "") {
        //从纯web进来没有urlData
        userId = that.$route.params.userId;
        userName = that.$route.params.userName;
      } else {
        userId = JSON.parse(that.$store.state.urlData.userJson).user_id;
        userName = that.$store.state.urlData.username;
      }
      var params = {
        username: userName,
        user_id: userId
      };
      if (MaxId !== "") {
        params.max_id = MaxId;
      }
      insMedia(params).then(
        response => {
          // success callback
          //  return response.body
          console.log(response.data);

          if (response.data.items.length == 0) {
            // that.$store.commit('updateEmptyMedia', {
            //   emptyMedia: true
            // })
            if (successCallBack) {
              successCallBack();
            }
            return;
          }
          // that.$store.commit('updateEmptyMedia', {
          //   emptyMedia: false
          // })
          that.$store.commit("updateUserMediaList", {
            userMediaList: response.data.items
          });

          that.$store.commit("updateMediaListTag", {
            mediaListTag: {
              more_available: response.data.more_available,
              max_id: response.data.next_cursor
            }
          });
          if (successCallBack) {
            successCallBack();
          }
          console.info(that.$store.state.mediaListTag);
        },
        response => {
          // error callback

          ga("send", {
            hitType: "event",
            eventCategory: "Get_user_media_data failed",
            eventAction: "net_err"
          });

          console.log("获取userMedia失败:" + response);
          if (falseCallBack) {
            falseCallBack();
          }
          store.dispatch("updateToastShow", {
            //失败Toast
            toastShow: true,
            toastText: "Get userMedia failed."
          });
        }
      );
    }

    getData();
  }
};

Vue.prototype.postFreeData = async (
  dataJson,
  successCallBack,
  errorCallBack
) => {
  console.log(isLocalStorageMain());
  store.dispatch("updateMidLoadingShow", {
    //显示loading
    midLoadingShow: true,
    midLoadingText: "Loading order"
  });
  console.log("dataJson:", dataJson);

  //先请求check:
  const { user_id } = dataJson;
  const masterId = store.state.masterId;
  try {
    const freeCheckResult = await freeCheck(masterId, user_id);
    console.log("freeCheckResult:", freeCheckResult);
    //如果可以校验通过：
    if (
      freeCheckResult.data &&
      freeCheckResult.data.data &&
      freeCheckResult.data.data.free_status === 1
    ) {
      console.log("经过校验");
    } else {
      errorCallBack();
      store.dispatch("updateToastShow", {
        //失败Toast
        toastShow: true,
        toastText: "You have got free followers."
      });
      store.dispatch("updateMidLoadingShow", {
        //隐藏loading
        midLoadingShow: false,
        midLoadingText: ""
      });
      if (isLocalStorageMain()) {
        localStorage.setItem("freeFollow", "true");
      }
      return;
    }
    const deliverRestul = await freeDeliver({
      ...dataJson,
      platform: basePlatform
    });
    console.log(deliverRestul.data);
    store.dispatch("updateMidLoadingShow", {
      //隐藏loading
      midLoadingShow: false,
      midLoadingText: ""
    });
    if (deliverRestul.data.data && deliverRestul.data.data.expected) {
      //成功回调后
      if (isLocalStorageMain()) {
        localStorage.setItem("freeFollow", "true");
      }
      if (successCallBack) {
        //如果有成功的回调函数则执行
        successCallBack();
      }
    } else {
      store.dispatch("updateToastShow", {
        //失败Toast
        toastShow: true,
        toastText: "Get free followers failed."
      });

      if (isLocalStorageMain()) {
        localStorage.setItem("freeFollow", "true");
      }
    }
  } catch (error) {
    console.log("postFreeData error:", error);
    ga("send", {
      hitType: "event",
      eventCategory: "Post_free_follow_data failed",
      eventAction: "net_err"
    });

    store.dispatch("updateMidLoadingShow", {
      //隐藏loading
      midLoadingShow: false,
      midLoadingText: ""
    });
    store.dispatch("updateToastShow", {
      //失败Toast
      toastShow: true,
      toastText: "Connect failed"
    });
  }
};

Vue.prototype.setUrlDataLocalStorage = function() {
  let dataJson = {
    data: store.state.urlData,
    url: store.state.dataUrl,
    full_url: window.location.href
  };
  //console.info(window.location.href)

  let data = JSON.stringify(dataJson);

  localStorage.setItem("urlData", data);
  let finalData = localStorage.getItem("urlData");
  console.info(JSON.parse(finalData));
};

Vue.prototype.getUrlDataLocalStorage = function() {
  let data = localStorage.getItem("urlData");
  return JSON.parse(data);
};

Vue.prototype.getUserslocalStorage = function() {
  var usersData = localStorage.getItem("usersData");
  if (usersData) {
    var newObj = JSON.parse(usersData);
    return newObj;
  } else if (usersData == null || userData.length == 0) {
    return null;
  }
};

Vue.prototype.setUserslocalStorage = function(obj) {
  var usersData = localStorage.getItem("usersData");
  var Arr = JSON.parse(usersData);
  if (Arr == null || Arr.length == 0) {
    var arr = [];
    arr.unshift(obj);
    var newArr = JSON.stringify(arr);
    console.log(newArr);
    localStorage.setItem("usersData", newArr);
  } else {
    //var arr = JSON.parse(usersData);
    if (this.contains(Arr, obj)) {
    } else {
      Arr.unshift(obj);
      var newArr = JSON.stringify(Arr);
      localStorage.setItem("usersData", newArr);
    }
  }
  console.info(localStorage.getItem("usersData"));
};

Vue.prototype.contains = function(Arr, obj) {
  for (var i in Arr) {
    if (JSON.stringify(Arr[i]) == JSON.stringify(obj)) {
      return true;
    }
  }
  return false;
};

Vue.prototype.deleteUserslocalStorage = function(obj) {
  var usersData = localStorage.getItem("usersData");

  if (usersData) {
    var arr = JSON.parse(usersData);
    var newArr = [];
    for (var i in arr) {
      if (JSON.stringify(arr[i]) === JSON.stringify(obj)) {
      } else {
        newArr.push(arr[i]);
      }
    }
    var finalArr = JSON.stringify(newArr);
    // console.log(finalArr)
    localStorage.setItem("usersData", finalArr);
  } else {
    return false;
  }
};

Vue.prototype.getIdByIndex = function(index) {
  return this.$store.state.userMediaList[index].id;
};

Vue.prototype.getIndexById = function(Id) {
  for (var i in this.$store.state.userMediaList) {
    if (this.$store.state.userMediaList[i].id == Id) {
      return i;
    }
  }
};

export { store };



// WEBPACK FOOTER //
// ./src/main.js